import { AnalyticsSpecs } from 'js/project/setup/personalization/components/PersonalizationWizard';
import fetchWrapper from '../fetchWrapper';

export function submitPersonalizationWizardForm(groupId: string, form: AnalyticsSpecs): Promise<unknown> {
  return fetchWrapper(`/${groupId}/setup/personalization`, {
    method: 'POST',
    body: JSON.stringify({ ...form }),
  });
}
